import {
  all,
  call,
  put,
  select,
  takeEvery,
  takeLatest,
} from 'redux-saga/effects';
import {getQueryString} from 'utils/queryString';

import request from 'utils/request';
import {makeSelectUserToken} from 'reducers/selectors/userSelectors';

import {
  CONNECT_POST,
  connectPostFailed,
  connectPostSuccess,
  CREATE_COMPETITION,
  createCompetitionsFailed,
  createCompetitionsSuccess,
  FETCH_COMPETITION_POSTS,
  FETCH_COMPETITIONS,
  fetchCompetitionPostsFailed,
  fetchCompetitionPostsSuccess,
  fetchCompetitionsFailed,
  fetchCompetitionsSuccess,
  UPDATE_COMPETITION,
  updateCompetitionsFailed,
  updateCompetitionsSuccess,
} from 'actions/competitionActions';

export default function* competitionSaga() {
  function* createCompetitions(action) {
    const authToken = yield select(makeSelectUserToken());
    const requestUrl = `competition`;
    const requestOptions = {
      method: 'POST',
      body: JSON.stringify(action.details),
    };

    try {
      const response = yield call(
        request,
        requestUrl,
        authToken,
        requestOptions
      );

      yield put(createCompetitionsSuccess(response.competition));
    } catch (err) {
      yield put(createCompetitionsFailed(err));
    }
  }

  function* updateCompetitions(action) {
    const authToken = yield select(makeSelectUserToken());
    const requestUrl = `competition/${action.id}`;
    const requestOptions = {
      method: 'PUT',
      body: JSON.stringify(action.details),
    };

    try {
      const response = yield call(
        request,
        requestUrl,
        authToken,
        requestOptions
      );
      yield put(updateCompetitionsSuccess(response.competition));
    } catch (err) {
      yield put(updateCompetitionsFailed(err));
    }
  }

  function* connectPost(action) {
    const authToken = yield select(makeSelectUserToken());
    // let requestUrl = `competition/${action.id}/${action.postId}`;
    console.log('connectPost', action);
    let requestUrl = `competition`;
    if (action.remove) requestUrl += `/remove`;
    else if (action.winner) requestUrl += `/winner`;
    else if (
      action.details &&
      (action.details.rating !== undefined ||
        action.details.comment !== undefined)
    )
      requestUrl += `/judge`; // TO change to judge role
    else requestUrl += `/apply`;

    const requestOptions = {
      method: 'PUT',
      body: JSON.stringify(action.details),
    };

    try {
      const response = yield call(
        request,
        requestUrl,
        authToken,
        requestOptions
      );

      yield put(
        connectPostSuccess(response.competition, action.remove, action.postId)
      );
    } catch (err) {
      yield put(connectPostFailed(err));
    }
  }

  function* fetchCompetitionPosts(action) {
    action.filters.isCompetition = true; // competition/posts?pageSize=50&pageNumber=0&isCompetition=true
    const params = getQueryString(action.filters);
    const requestUrl = `competition/posts?${params}`;
    const authToken = yield select(makeSelectUserToken());

    const requestOptions = {};
    try {
      const response = yield call(
        request,
        requestUrl,
        authToken,
        requestOptions
      );
      yield put(
        fetchCompetitionPostsSuccess(response.posts, response.statuses)
      );
    } catch (err) {
      yield put(fetchCompetitionPostsFailed(err));
    }
  }

  function* fetchCompetitions() {
    const requestUrl = `competition`;
    const authToken = yield select(makeSelectUserToken());

    const requestOptions = {};
    try {
      const response = yield call(
        request,
        requestUrl,
        authToken,
        requestOptions
      );
      yield put(fetchCompetitionsSuccess(response.competitions));
    } catch (err) {
      yield put(fetchCompetitionsFailed(err));
    }
  }

  yield all([
    takeLatest(FETCH_COMPETITION_POSTS, fetchCompetitionPosts),
    takeEvery(CREATE_COMPETITION, createCompetitions),
    takeLatest(FETCH_COMPETITIONS, fetchCompetitions),
    takeLatest(UPDATE_COMPETITION, updateCompetitions),
    takeLatest(CONNECT_POST, connectPost),
  ]);
}
